// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__fy2tx","insightsList":"newBusinessInsightsMenu_insightsList__2_hf-","active":"newBusinessInsightsMenu_active__rP-Rx"};